import { render, staticRenderFns } from "./activeClient.vue?vue&type=template&id=7bb37558&scoped=true"
import script from "./activeClient.vue?vue&type=script&lang=js"
export * from "./activeClient.vue?vue&type=script&lang=js"
import style0 from "./activeClient.vue?vue&type=style&index=0&id=7bb37558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb37558",
  null
  
)

export default component.exports